import i18n, { InitOptions } from "i18next";

import { initReactI18next } from "react-i18next";

export const initTranslation = (options: InitOptions) => {
    const optionsLang = options.lng || "";
    const isoCode = optionsLang.substring(0, 2);
    const langCode = optionsLang.substring(3).toUpperCase();
    const lang = `${isoCode}-${langCode}`;

    i18n.use(initReactI18next) // passes i18n down to react-i18next
        .init({
            fallbackLng: [],
            interpolation: {
                escapeValue: false, // React already safes from xss
            },
            react: {
                useSuspense: false,
            },
            ...options,
            lng: lang,
        });
};
